export default {
  FREE: { value: 0, label: "FREE" },
  WITH_VAT: { value: 1, label: "WITH_VAT" },
  WITHOUT_VAT: { value: 2, label: "WITHOUT_VAT" },
  BOTH_VAT: { value: 3, label: "BOTH_VAT" },
};